import ConfirmDeleteModal from "@/components/shared/ConfirmDeleteModal/ConfirmDeleteModal";
import Edit02Icon from "@/components/shared/icons/Edit02Icon";
import { ToastSuccess } from "@/components/shared/toast/Toast";
import {
  CButton,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
  CSmartTable,
} from "@coreui/react-pro";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import { createIndexes } from "../../../shared/utils/ultils";
import { AppDispatch } from "../../../store";
import CustomTableFooter from "../../shared/CustomTableFooter/CustomTableFooter";
import FilterIcon from "../../shared/icons/FilterIcon";
import PlusIcon from "../../shared/icons/PlusIcon";
import SearchIcon from "../../shared/icons/SearchIcon";
import TrashIcon from "../../shared/icons/TrashIcon";
import {
  getEntities,
  removeEntity,
  updateEntity,
} from "./injectionManagement.api";
import InjectionUpdate from "./InjectionUpdate";
import { IInjection } from "@/shared/model/injection.model";
import {
  fetching,
  injectionSelectors,
  resetEntity,
  setFilterState,
} from "./injectionManagement.reducer";
import {
  mapOrderResponseStatus,
  mapOrderResponseStatusToColor,
} from "@/shared/enumeration/OrderResponseStatus";
import dayjs from "dayjs";

const columns = [
  {
    key: "id",
    label: "ID",
    sorter: false,
  },
  {
    key: "userId",
    label: "Thành viên",
    sorter: false,
  },
  {
    key: "rate",
    label: "Tỷ lệ",
    sorter: false,
  },
  {
    key: "thuTu",
    label: "Dơn thứ",
    sorter: false,
  },
  {
    key: "orderId",
    label: "Mã đơn",
    sorter: false,
  },
  {
    key: "createdDate",
    label: "Thời gian",
    sorter: false,
  },
  {
    key: "status",
    label: "Tình trạng",
    sorter: false,
    _props: { width: "20%" },
  },
  {
    key: "actions",
    label: "Thao tác",
    sorter: false,
    _props: { className: "text-center" },
  },
];

interface IIndexInjection extends IInjection {
  index: number;
}

const InjectionManagement = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { initialState } = useSelector(
    (state: RootState) => state.injectionsReducer
  );
  const {
    filterState,
    totalItems,
    totalPages,
    loading,
    updateEntitySuccess,
    deleteEntitySuccess,
  } = initialState;
  const [createInjection, setCreateInjection] = useState<boolean>(false);
  const [updateInjection, setUpdateInjection] = useState<IInjection | null>(
    null
  );

  const handleCreateInjection = () => {
    setCreateInjection(true);
  };

  const handleUpdateInjection = (injection: IInjection) => () => {
    setUpdateInjection(injection);
  };

  const handleCancelUpdateInjection = (update?: boolean) => {
    setUpdateInjection(null);
  };

  const handlePaginationChange = (page: number) => {
    if (page !== 0) {
      window.scrollTo(0, 0);
      dispatch(setFilterState({ ...filterState, page: page, keyword }));
    }
  };

  const injections = useSelector(injectionSelectors.selectAll);
  console.log(injections, "injectionsinjections");
  const indexedInjection = createIndexes(injections, filterState);

  useEffect(() => {
    if (updateEntitySuccess && !createInjection && !updateInjection) {
      ToastSuccess("Cập nhật trạng thái thành công");
      dispatch(resetEntity());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateEntitySuccess]);

  useEffect(() => {
    if (!deleteEntitySuccess) {
      dispatch(fetching());
      dispatch(getEntities(filterState));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(filterState), deleteEntitySuccess]);

  useEffect(() => {
    if (deleteEntitySuccess) {
      ToastSuccess("Xoá đơn hàng thành công");
      dispatch(resetEntity());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteEntitySuccess]);

  const [chosenDelete, setChosenDelete] = useState<IInjection | null>(null);

  const handleDelete = () => {
    if (chosenDelete) {
      dispatch(removeEntity(chosenDelete.id.toString()));
      setChosenDelete(null);
    }
  };

  const handleCancelDelete = () => {
    setChosenDelete(null);
  };

  const [keyword, setKeyword] = useState<string>("");

  const onSearch = () => {
    dispatch(getEntities({ ...filterState, keyword }));
  };

  return (
    <>
      <div className="tab-outlet-content">
        <div className="table-context">
          <div className="d-flex">
            <CFormInput
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="ID hoặc Tên đăng nhập"
            />
            <CButton
              style={{ height: 42, whiteSpace: "nowrap" }}
              className="ms-2 btn-custom btn-sm text-white"
              onClick={onSearch}
            >
              Tìm kiếm
            </CButton>
          </div>
          <div>
            <CButton
              className="btn-custom primary-500 btn-sm"
              onClick={handleCreateInjection}
            >
              <PlusIcon /> Tiêm đơn
            </CButton>
          </div>
          <div className="d-none">
            <CInputGroup className="search-group me-2">
              <CInputGroupText id="search-addon">
                <SearchIcon />
              </CInputGroupText>
              <CFormInput
                placeholder="Tìm kiếm theo tên"
                aria-label="Injectionname"
                aria-describedby="basic-addon1"
              />
            </CInputGroup>
            <CButton className="btn-custom gray-700 btn-sm">
              <FilterIcon /> Lọc
            </CButton>
          </div>
        </div>

        <div className="table-content">
          <CSmartTable
            header
            loading={loading}
            columns={columns}
            items={indexedInjection}
            clickableRows
            noItemsLabel="Không có bản ghi"
            itemsPerPage={filterState.limit}
            scopedColumns={{
              createdDate: ({ index, ...value }: IIndexInjection) => (
                <td>
                  {dayjs(value.createdDate).format("DD/MM/YYYY HH:mm:ss")}
                </td>
              ),
              orderId: ({ index, ...value }: IIndexInjection) => (
                <td>{value.order?.code}</td>
              ),
              userId: ({ index, ...value }: IIndexInjection) => (
                <td>{value.user?.username}</td>
              ),
              rate: ({ index, ...value }: IIndexInjection) => (
                <td>{value.rate}</td>
              ),
              status: ({ index, ...value }: IIndexInjection) => (
                <td>
                  {/* {value.orderId ? (
                    <span className="badge bg-success">Đã hoàn thành</span>
                  ) : (
                    <span className="badge bg-secondary">Chưa hoàn thành</span>
                  )} */}
                  <span
                    className={`badge bg-${
                      value?.order?.status
                        ? mapOrderResponseStatusToColor[value?.order?.status]
                        : "dark"
                    }`}
                  >
                    {value?.order?.status
                      ? mapOrderResponseStatus[value?.order?.status]
                      : "Mới tạo"}
                  </span>
                </td>
              ),
              actions: ({ index, ...value }: IIndexInjection) => (
                <td>
                  <CInputGroup className="custom-input-group-action justify-content-center">
                    {!value.orderId && (
                      <CInputGroupText onClick={handleUpdateInjection(value)}>
                        <Edit02Icon />
                      </CInputGroupText>
                    )}
                    <CInputGroupText onClick={() => setChosenDelete(value)}>
                      <TrashIcon />
                    </CInputGroupText>
                  </CInputGroup>
                </td>
              ),
            }}
            tableProps={{
              hover: true,
              align: "middle",
              responsive: "lg",
              className: "custom-table",
            }}
            tableHeadProps={{
              className: "table-head",
            }}
            tableBodyProps={{
              className: "table-body",
            }}
          />
        </div>

        {createInjection ? (
          <InjectionUpdate
            visible={createInjection}
            setVisible={setCreateInjection}
          />
        ) : (
          ""
        )}
        {updateInjection ? (
          <InjectionUpdate
            visible={Boolean(updateInjection)}
            injectionObj={updateInjection}
            setVisible={handleCancelUpdateInjection}
          />
        ) : (
          ""
        )}
        <CRow>
          <CustomTableFooter
            totalItems={totalItems}
            hideSideChosen
            totalPages={totalPages}
            filterState={filterState}
            setFilterState={(filter) => dispatch(setFilterState(filter))}
            handlePaginationChange={handlePaginationChange}
          />
        </CRow>
      </div>
      {chosenDelete ? (
        <ConfirmDeleteModal
          visible={Boolean(chosenDelete)}
          handleOnClose={handleCancelDelete}
          handleDelete={handleDelete}
          title="Xoá khỏi hệ thống"
          content={<>Xác nhận xoá khỏi hệ thống?</>}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default InjectionManagement;
